import angular from 'angular';
import bySearchComponent from './by-search.component';
import bySearchConfig from './by-search.config';
import BySearchController from './by-search.controller';
import BySearchService from './by-search.service';

let bySearchModule = angular.module('app.bySearch', [])
    .component('bySearch', bySearchComponent)
    .controller('BySearchController', BySearchController)
    .service('BySearchService', BySearchService)
    .config(bySearchConfig);

export default bySearchModule;



// WEBPACK FOOTER //
// ./www/components/fast-purchase/by-search/by-search.js